import { authApi } from './apis';
import { Credentials, AuthResponseInterface } from '@types';

const ROUTES = {
  login: '/login',
};

export function authUser(data: Credentials) {
  return authApi.post<AuthResponseInterface>(ROUTES.login, data);
}
